import { Controller } from "@hotwired/stimulus"

// Drawer helper for saved reports. Turbo drives the list itself (create/rename/delete
// re-render the frame); this fills the gaps Turbo can't: copying a shared report's link
// to the clipboard, and clearing the "Save report" name field after a successful save.
export default class extends Controller {
  static targets = ["name", "copyLabel"]

  // Copy a shared report's absolute link (passed as an action param) to the clipboard,
  // with brief in-place feedback on the clicked button's label.
  async copy(event) {
    const url = event.params.url
    const label = event.currentTarget.querySelector("[data-reporting--saved-reports-target='copyLabel']")
    try {
      await navigator.clipboard.writeText(url)
      this.flash(label, "Copied!")
    } catch (error) {
      console.error("Copy failed", error)
      this.flash(label, "Copy failed")
    }
  }

  // Clear the name field after a successful save so the drawer is ready for the next one.
  saved(event) {
    if (event.detail?.success && this.hasNameTarget) this.nameTarget.value = ""
  }

  flash(label, message) {
    if (!label) return
    const original = label.textContent
    label.textContent = message
    setTimeout(() => { label.textContent = original }, 2000)
  }
}
